import { CircularProgress } from '@mui/material';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
    flex: 1;
`;

export const CircularProgressIndicator = () => {
    return (
        <Container>
            <CircularProgress style={{ alignSelf: 'center' }} disableShrink />
        </Container>
    );
};
